import { useState } from 'react';

export function useProgress() {
  const [progressPercent, setProgressPercent] = useState(0);

  const onProgressEvent = (progressEvent: ProgressEvent) => {
    setProgressPercent((progressEvent.loaded / progressEvent.total) * 100);
  };

  return { progressPercent, onProgressEvent };
}
